export const authDebugEnabled = process.env.NEXT_PUBLIC_AUTH_DEBUG === "true";

export function authDebug(message: string, context?: Record<string, unknown>) {
  if (!authDebugEnabled) return;
  console.info(message, context ?? {});
}
